import {TextButton} from '../../../index'
import {englishTexts} from '../../../../../consts/Texts'

const ImageUploadButton = ({onClick}) => {
    return (
        <TextButton clickHandler={onClick}>{englishTexts.buttons.chooseImage}</TextButton>
    )
}

export default ImageUploadButton
